/**
 * Setting 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  userAgreement: 'User Agreement',
  privacyPolicy: 'Privacy Policy',
  accountCancellation: 'Account cancellation',
  autoUnlock: 'Auto-unlock',
  autoSubscriptionRenewal: 'Auto subscription renewal',
  importantOperation: 'Important operation',
  accountCancellationConfirm: 'Are you sure you want to close your account? If you confirm the cancellation, we will delete all your user information on the platform, including but not limited to your account information (and will also cancel the binding relationship between your account and the third party account), viewing records, recharge and consumption records, and the balance in your account! You will no longer be able to retrieve this account, please exercise caution.',
  verify: 'Verify',
  cancel: 'Cancel',
  confirm: 'Confirm',
  accountCancellationSuccess: 'Account cancellation success',
  autoUnlockSuccess: 'Auto-unlock setting success',
  autoSubscriptionRenewalSuccess: 'Auto subscription renewal setting success',
  cancelRenewalTip: 'After canceling the renewal, no deduction will be made in the next period, and you can use it normally in the current period.',
} as const

export const settingCommonConfig = {
  texts: commonTexts,
}
